module.exports = __webpack_public_path__ + "img/co.69f7239b.svg";